import { useState } from "react";

/**
 * 구독 아이콘(사진, 2026-10-07) — 있으면 그 사진, 없거나 못 받으면 토픽 이름 첫 글자.
 * 아이콘은 서버가 256px 정사각으로 잘라 둔 것이라 object-cover 로 그대로 채운다.
 */
interface TopicAvatarProps {
  topic: string;
  icon?: string | null;
  /** 안 읽음 — 글자는 강조색, 사진은 테두리로 */
  unread?: boolean;
  className?: string;
}

const TopicAvatar = ({ topic, icon, unread = false, className = "size-8" }: TopicAvatarProps) => {
  const [failed, setFailed] = useState<string | null>(null);
  const initial = (topic || "?").slice(0, 1).toUpperCase();
  if (icon && failed !== icon) {
    return (
      <span
        aria-hidden
        className={`inline-flex shrink-0 overflow-hidden rounded-lg ${unread ? "ring-primary ring-2 ring-offset-1 ring-offset-background" : "opacity-75"} ${className}`}
      >
        <img src={icon} alt="" loading="lazy" className="size-full object-cover" onError={() => setFailed(icon)} />
      </span>
    );
  }
  return (
    <span
      aria-hidden
      className={`inline-flex shrink-0 items-center justify-center rounded-lg text-sm font-bold ${
        unread ? "bg-primary-soft text-primary-soft-foreground" : "bg-secondary text-muted-foreground"
      } ${className}`}
    >
      {initial}
    </span>
  );
};

export default TopicAvatar;
